/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeviceControllerDeleteSchedule$Params {
  deviceId: string;
  scheduleId: string;
  clientWorkspaceId: string;
}

export function deviceControllerDeleteSchedule(http: HttpClient, rootUrl: string, params: DeviceControllerDeleteSchedule$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deviceControllerDeleteSchedule.PATH, 'delete');
  if (params) {
    rb.path('deviceId', params.deviceId, {});
    rb.path('scheduleId', params.scheduleId, {});
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deviceControllerDeleteSchedule.PATH = '/api/device/{clientWorkspaceId}/{deviceId}/schedules/{scheduleId}';
